import styled from 'styled-components';

const SidebarBox = styled.div`
    padding: 28px var(--sidebar-padding);
    border-bottom: 1px solid var(--container-border-color-100);
    position: relative;
    word-break: break-word;

    ${({borderNone}) => {
        if (borderNone === true)
            return `
            border: none;
        `;
        else return ``;
    }}
`;

const SidebarContent = styled.div`
    padding-bottom: var(--sidebar-padding);
`;

export {SidebarBox, SidebarContent};
